import store from '@/store/store.js'
import axios from 'axios'

import Compressor from 'compressorjs'
import childApi from '@/api/child'

/**
 * Upload custom child avatar.
 *
 * @param group_id
 * @param child_id
 * @param avatar
 * @returns Promise
 */
export const uploadAvatar = async (child_id, avatar) => {
  const data = new FormData()
  data.append('avatar', avatar)

  const url = await childApi.getUploadAvatarUrl(child_id)

  try {
    await axios.post(url, data)
  } catch(err) {
    //console.log(err, 'ERROR')
  }

  const updatedChild = await childApi.get(['avatar_download_url'], [child_id])
  const { avatar_download_url, avatar_id } = updatedChild[0]

  store.commit('children/updateChild', {
    child_id,
    attributes: {
      avatar_download_url,
      avatar_id
    }
  })
}

/**
 * Compress uploaded image size.
 *
 * @param image
 * @param callback
 * @returns Object
 */
export const compressImage = (image, callback) => {
  return new Compressor(image, {
    quality: 0.2,
    width: 480,
    height: 480,
    convertSize: 0,
    success: callback
  })
}


/**
 * Change child avatar to default one.
 *
 * @param group_id
 * @param child_id
 * @param avatar
 * @returns Promise
 */
export const changeDefaultAvatar = (group_id, child_id, avatar_id) => {
  // return updateChild(child_id, {
  //   avatar_id
  // })

  return store.dispatch('children/updateChild', {
    child_id,
    data: {
      avatar_id
    }
  })
}